import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IToChucThiReducer } from "../../reducer-model/category/IToChucThiReducer";
import { IToChucThiActionTypes } from "../../action-types/category/IToChucThiActions";
import { IThongTinToChucThiRequest } from "../../../model/request/category/IThongTinToChucThiRequest";

const iniState: IToChucThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  toChucThis: [],
  statusDotThi: eReducerStatusBase.is_not_initialization,
  dotThis: [],
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_mon: 0,
    id_dot_thi: 0,
  } as IThongTinToChucThiRequest,
};

export const ToChucThiReducer = (
  state: IToChucThiReducer = iniState,
  action: IToChucThiActionTypes
): IToChucThiReducer => {
  switch (action.type) {
    case "TO_CHUC_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TO_CHUC_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        toChucThis: action.payload,
      };
    case "TO_CHUC_THI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TO_CHUC_THI_LOAD_DOT_THI_START":
      return {
        ...state,
        statusDotThi: eReducerStatusBase.is_loading,
      };
    case "TO_CHUC_THI_LOAD_DOT_THI_SUCCESS":
      return {
        ...state,
        statusDotThi: eReducerStatusBase.is_completed,
        dotThis: action.payload,
      };
    case "TO_CHUC_THI_LOAD_DOT_THI_ERRR":
      return {
        ...state,
        statusDotThi: eReducerStatusBase.is_completed,
      };
    case "TO_CHUC_THI_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
